// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__1Xg6R","overlay":"Loading_overlay__2cu7_"};